import { useSelector } from "@/core/redux/store";
import { RootState } from "@/core/redux/store";
import { Skeleton } from "@/shared/components/ui/skeleton";
import useGridTemplate from "../../utils/useGridTemplate";

export default function LoadingState() {
  const { hiddenColumnFields } = useSelector(
    (state: RootState) => state.supplierResponsesAll
  );

  const isColumnVisible = (field: string) => {
    return !hiddenColumnFields.includes(field);
  };

  const gridTemplate = useGridTemplate();

  // Generate 5 skeleton rows
  const skeletonRows = Array.from({ length: 5 }, (_, index) => index);

  return (
    <div className="w-full">
      {skeletonRows.map((_, rowIndex) => (
        <div
          key={rowIndex}
          className="grid items-center w-full h-[56px] last:border-b-0 border-b border-border animate-pulse"
          style={{
            gridTemplateColumns: gridTemplate,
          }}
        >
          {/* Specification Name column */}
          <div className="flex items-center pl-[45px] pr-3 py-2 relative h-full">
            <div className="flex items-center justify-center w-[45px] h-full absolute left-0 top-0">
              <Skeleton className="w-4 h-4 rounded" />
            </div>
            <div className="flex flex-col gap-1">
              <Skeleton className="h-4 w-[180px] rounded" />
              <Skeleton className="h-3 w-[120px] rounded" />
            </div>
          </div>

          {/* Products column */}
          <div className="flex items-center gap-1 px-[8px] h-full">
            <div className="flex items-center gap-1">
              <Skeleton className="w-8 h-8 rounded-md" />
              <Skeleton className="w-8 h-8 rounded-md" />
            </div>
          </div>

          {/* Item Count column */}
          {isColumnVisible("itemCount") && (
            <div className="flex items-center justify-center px-[8px] h-full">
              <Skeleton className="h-5 w-8 rounded" />
            </div>
          )}

          {/* Answered column */}
          {isColumnVisible("answered") && (
            <div className="flex items-center justify-center px-[8px] h-full">
              <div className="flex -space-x-2">
                <Skeleton className="w-8 h-8 rounded-full border-2 border-white" />
                <Skeleton className="w-8 h-8 rounded-full border-2 border-white" />
                <Skeleton className="w-8 h-8 rounded-full border-2 border-white" />
              </div>
            </div>
          )}

          {/* Not Answered column */}
          {isColumnVisible("notAnswered") && (
            <div className="flex items-center justify-center px-[8px] h-full">
              <div className="flex -space-x-2">
                <Skeleton className="w-8 h-8 rounded-full border-2 border-white" />
                <Skeleton className="w-8 h-8 rounded-full border-2 border-white" />
              </div>
            </div>
          )}

          {/* Item Status column */}
          {isColumnVisible("itemStatus") && (
            <div className="flex items-center justify-center px-[8px] h-full">
              <Skeleton className="h-7 w-[160px] rounded-full" />
            </div>
          )}

          {/* Status column */}
          {isColumnVisible("status") && (
            <div className="flex items-center justify-center px-[8px] h-full">
              <Skeleton className="h-5 w-[100px] rounded-full" />
            </div>
          )}

          {/* Actions column */}
          <div className="flex">
            <div className="flex items-center justify-center h-full relative w-[41px]">
              <Skeleton className="w-8 h-8 rounded" />
            </div>
            <div className="flex items-center justify-center px-[8px] h-full relative w-[41px]">
              <Skeleton className="w-8 h-8 rounded" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
